// extracted by mini-css-extract-plugin
export var container = "_6t-0";
export var containerTopRight = "_6t-1";